import { render, staticRenderFns } from "./BalanceDetail.vue?vue&type=template&id=8a60e8c0&"
import script from "./BalanceDetail.vue?vue&type=script&lang=js&"
export * from "./BalanceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports